<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Hub To Hub</strong>           
          </div>
          <div class="box">
            <form @submit.prevent="validateForm2('form-1')" data-vv-scope="form-1">

            <b-row>
            <b-col md="4"> 
                <b-form-group label="Shipment list"  :label-cols="4" >
                  <vue-tags-input
                  v-model="shipmentIds" 
                  :tags="tags"
                   @tags-changed="newTags => tags = newTags "
                   :placeholder="placeholder"
                    ref="taginput"
                   v-bind:separators="[',', ';']"
                     />
                    </b-form-group> 
             </b-col>   

            <b-col md="4">                            
                <b-form-group label="Hub"  :label-cols="4" >
                   <b-form-select class="form-control input" v-model="customer.destinationhubid" name="destinationhubid" v-validate="'required|'" :class="{'input': true, }">
                        <option :value="selected"  >--Select--</option>
                        <option v-for="hub in hublist"   v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
                   </b-form-select>
                  <span v-show="errors.has('form-1.destinationhubid')" class="help text-danger">{{ errors.first('form-1.destinationhubid') }}</span>            
                </b-form-group> 
              </b-col>


              <!-- <b-col md="3">                            
                <b-form-group label="Delivery Agent"  :label-cols="4" >
                 <b-form-select class="form-control input" v-model="customer.deliveryagentid" name="deliveryagentid" v-validate="'required|'" :class="{'input': true, }">
                        <option :value="selected"  >--Select--</option>
                        <option v-for="agent in agentmaster"  v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname | capitalize }} {{ agent.deliveryagentlastname | capitalize }} {{agent.deliveryagentmasterid}}</option>
                   </b-form-select>
                  
                  <span v-show="errors.has('form-1.deliveryagentid')" class="help text-danger">{{ errors.first('form-1.deliveryagentid') }}</span>            
                </b-form-group> 
              </b-col> -->
              <b-col md="3">
                <b-button class="mr-2" type="submit" size="md" variant="primary">Submit</b-button>
              
               
                
              </b-col> 
            </b-row>     
          </form>
          </div>
       
       </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<style>  
.scroll {  
    width: 200px;  
    height: 100px;  
    overflow: scroll;  
}  
</style> 
<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueTagsInput from '@johmun/vue-tags-input';
export default {

  data: function() {
    return {
      name: 'reattemptshipment',
      shipmentlist: [],
      users: [
        { shippingid: '1000032' },
        { shippingid: '1000033' },
        { shippingid: '1000038' },
        { shippingid: '1000039' }
      ],
      agentmaster: [],
      hublist: [],
      currenthubidselct:'',
      customer: {},
      selected: [],
      allSelected: false,
      shipmentIds: [],
      tags: [],
    }
  },
  components: {
    VueTagsInput,
  },
  created: function() {
    this.displaydata();
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    this.currenthubidselct=userInfo.pickuplocationmasterid.toString();

  },
  methods: {
      selectAll: function() {
            this.shipmentIds = [];

            if (this.allSelected) {

                for (data in this.value) {
                    this.shipmentIds.push(this.value[data].shippingid.toString());
                }
            }
      },
      
      select: function() {
          this.allSelected = false;
      },

      displaydata: function() {
  
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)


        //agentmaster
        // const deliveryagent = {
        //   deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        //   isactive: '1'
        // }
        // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        //   .then((result) => {
        //     this.agentmaster = result.body
        //   })
        //   .catch((ex) => {
        //     console.log('error', ex)
        //   })


          //hublist
          var currenthub=userInfo.pickuplocationmasterid;
        var hubobj={
          hub_id: "365" //currenthub.toString()
        }

          this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
          .then(result => {
            if(result.body.returnmsg=='Successful'){
            this.hublist = result.body.returnvalue;
            }
            //console.log('mukesh',this.hublist);
          })
          .catch(ex => {
            console.log('error', ex)
          });
      //shipment

        // var currenthub=userInfo.pickuplocationmasterid;
        // var shipments={
        //   hub_id:currenthub.toString()
        // }
      
        // this.$http
        //   .post(
        //     `${CONSTANTS.MIGRATION_API_URL}/gethubinscanshipmentlist`,
        //     shipments
        //   )
        //   .then(result => {
        //     if(result.body.returnmsg=='Successful' && result.body.returnvalue){
        //     this.shipmentlist = result.body.returnvalue;
        //     }
        //   //this.shipmentlist=this.users;

        //     // console.log('this.shipmentlist1',this.shipmentlist);
        //   })
        //   .catch(ex => {
        //     console.log('error', ex)
        //   })
      },

      validateForm2: function(scope){

        var searchvaluesarr = []
        this.$validator.validateAll(scope).then((result) => {
          console.log("tags",this.tags)
          var shipmentid=[];
          for(var i = 0; i < this.tags.length; i++) {
              shipmentid.push(this.tags[i].text);  
          }
          if (result && this.tags.length > 0) {
            var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)

          var shipmentidget = this.customer.shipmentid;
          var currenthub=userInfo.pickuplocationmasterid;
          //  this.shipping.push(shipmentidget);
            const Getobj = {
              shippingid: shipmentid,
              currenthubid:currenthub.toString(),
              // deliveryagentid:this.customer.deliveryagentid,
              destinationhubid:this.customer.destinationhubid.toString(),
              lastmodifiedby: `${userInfo.sysemailid}`
            }
            console.log("obj",Getobj)
            // return false
            this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster/assignshipmentstonexthub`, Getobj)
              .then((result) => {
                this.customer = {};
                this.shipmentIds = [];
                shipmentid=[];
                // alert('Shipment transfer to hub successfully.');
                this.$fire({
                    text:"Shipment transfer to hub successfully",
                    type: "success",
                    timer: 30000
                  }); 
                  this.customer = {};
                this.shipmentIds = [];
                shipmentid=[];
                this.tags =[];
                if (result.body.returnmsg === "Successful") {
                this.$router.push('hubmaster') 
                } else {
                this.$router.push('hubmaster') 

                }
              })
              .catch((ex) => {
                console.log('error', ex)
              })
          }else{
              // alert('Please Enter atleast one shippment.');
              this.$fire({
                   text:"Please Enter atleast one shippment.",
                   type: "warning",
                   timer: 30000
                 });
          }
        })
      },
    
  },
  filters: {
    datechange: function(value) {
       if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    },
     capitalize: function(value) {
            return value.toUpperCase() || "";
        }
  }
}
</script>
<style>
li {
    list-style-type: none;
}
</style>
